import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';
import * as moment from 'moment';
import * as _ from 'lodash';

import { LoaderEvent } from './../../shared/message.event';
import { PrimecalendarService } from './../primecalendar.service';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { UtilityFunctions } from '../../shared/utility-functions';

@Component({
    selector: 'app-booking-entry',
    templateUrl: './booking-entry.component.html',
    styleUrls: ['./booking-entry.component.css'],
    providers: [LoaderEvent],
    exportAs: 'bookingEntryPopUpObj'
})
export class BookingEntryComponent implements OnInit {
    @ViewChild('childModal') childModal: ModalDirective;
    @Input() message = '';
    @Input() popupTitle;
    // @Output() notify: EventEmitter<string> = new EventEmitter<string>();
    @Output() notify = new EventEmitter<boolean>();
    @Output() notifyDelete = new EventEmitter<boolean>();
    private stringConstants = CONSTANT_MESSAGES;
    @Input() deleteMessage;
    @Input() bookingData = [];
    @Input() eventData;
    @Input() selectedUnit;
    @Input() facility;
    private waitList = [];
    private bookedList = [];
    private eventdate;
    private eventStartTime;
    private eventEndTime;
    private popUpMessage
    private actionOnBookingObj;
    private showIconFlag = true;
    private bookingDataList = [];
    private waitListCourtWise = []
    @Input() vendor;
    private timezoneOffset;
    @Output() payment = new EventEmitter<boolean>();
    @Output() deleteBookingEmitter = new EventEmitter<any>();
    @Output() bookingByFacility = new EventEmitter<boolean>();
    private utilityFunctions = new UtilityFunctions();
    constructor(private loaderEvent: LoaderEvent, private calendarService: PrimecalendarService) {
    }

    public showChildModal(): void {
        this.bookingDataList = this.bookingData
        this.timezoneOffset = this.vendor.timezoneOffset * -1;
        this.eventdate = this.utilityFunctions.maketimeZoneOfsetDate(this.eventData['start']).format('LL').toUpperCase();
        this.eventStartTime = this.utilityFunctions.maketimeZoneOfsetDate(this.eventData['start']).format('h A');
        this.eventEndTime = this.utilityFunctions.maketimeZoneOfsetDate(this.eventData['end']).format('h A');
        this.sort();
        this.actionOnBookingObj = {};
        this.showActionIcons();
        this.childModal.config.backdrop = false;
        this.childModal.show();
    }

    public hideChildModal(): void {
        this.childModal.hide();
    }

    ngOnInit() {
    }

    onClickOk() {
        this.notify.emit(true);
    }

    onClickCancle() {
        this.notify.emit(false);
    }
    /**
     * Separate bookings and wait list
     *
     *
     * @memberof BookingEntryComponent
     */
    sort() {
        let that = this;
        // _.remove(this.bookingDataList, function (n) {
        //     return n['allDay'];
        // });
        this.waitListCourtWise = [];
        this.bookedList = [];
        this.waitList = [];
        this.bookingDataList.forEach(element => {
            if (!element.allDay && that.CompareDate(element)) {
                if (element['attendees'] < 10) {
                    element['attendees'] = '0' + parseInt(element['attendees']);
                }
                if (element['bookingStatus'] == 'waitlist') {
                    that.waitList.push(element);
                } else {
                    that.bookedList.push(element)
                }
            }
        });
    }
    /**
     * Compare dates with given events
     *
     * @param {any} bookingStart
     * @param {any} bookingEnd
     * @returns
     *
     * @memberof BookingEntryComponent
     */
    CompareDate(momentDate) {
        let bookingStart = new Date(momentDate.startTime).getTime();
        let bookingEnd = new Date(momentDate.endTime).getTime();
        let eventStart = new Date(this.eventData.calEvent.startTime).getTime();
        let eventEnd = new Date(this.eventData.calEvent.endTime).getTime();
        return (eventStart < bookingEnd && eventEnd > bookingStart);
    }
    /**
     * Cancel booking
     *
     * @param {any} event
     * @param {any} popUpObj
     *
     * @memberof BookingEntryComponent
     */
    cancelBooking(event, popUpObj) {
        if (event) {
            let bookingObj = {
                'bookingId': this.actionOnBookingObj['bookingId'],
                '_id': this.actionOnBookingObj['userId'],
                'isFromVendor': true
            };
            this.loaderEvent.fire(false);
            this.calendarService.cancelBooking(bookingObj).then((result: any) => {
                this.loaderEvent.fire(true);
                if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
                    this.show(bookingObj);
                }
                else {
                    this.popUpMessage = result.message;
                    popUpObj.showChildModal();
                }
            });
            this.actionOnBookingObj = {};
        } else {
            this.showChildModal();
        }
    }
    /**
     * Open confirm booking popup
     *
     * @param {any} popUpObj
     * @param {any} bookingCancelObj
     *
     * @memberof BookingEntryComponent
     */
    showConfirmationPopup(popUpObj, bookingCancelObj) {
        this.actionOnBookingObj = bookingCancelObj;
        this.popUpMessage = CONSTANT_MESSAGES.CANCEL_BOOKING;
        this.hideChildModal();
        popUpObj.showChildModal();
    }

    makePayment(booking) {
        this.payment.emit(booking);
    }

    showConfirmationPopupForPayment(popUpObj, bookingCancelObj) {
        this.actionOnBookingObj = bookingCancelObj;
        this.popUpMessage = CONSTANT_MESSAGES.MAKE_PAYMENT;
        this.hideChildModal();
        popUpObj.showChildModal();
    }
    /**
     * Make payment
     *
     * @param {any} event
     * @param {any} popUpObj
     *
     * @memberof BookingEntryComponent
     */
    makePaymentForBooking(event, popUpObj) {
        if (event) {
            this.loaderEvent.fire(false);
            if (this.actionOnBookingObj && this.actionOnBookingObj.isPaymentDone != undefined && !this.actionOnBookingObj.isPaymentDone) {
                let that = this;
                let paymentObj = {
                    'bookingId': this.actionOnBookingObj.bookingId,
                    '_id': this.actionOnBookingObj.userId,
                    'vendorId': this.vendor['_id']
                };
                this.calendarService.makePayment(paymentObj).then((result: any) => {
                    this.loaderEvent.fire(true);
                    if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
                        this.show();
                    } else {
                        this.popUpMessage = result.message;
                        popUpObj.showChildModal();
                    }
                });
            } else {
            }

        } else {
            this.showChildModal();
        }
    }

    show(bookingObj?) {
        if (bookingObj) {
            this.deleteBookingEmitter.emit(bookingObj);
        } else {
            this.bookingByFacility.emit(true);
        }

    }
    /**
     * Show action icons conditionally
     *
     *
     * @memberof BookingEntryComponent
     */
    showActionIcons() {
        let currentDate = moment().utcOffset(this.timezoneOffset, true);
        if ((currentDate > this.eventData['startTimeNew']) || (this.vendor.role.indexOf(CONSTANT_VALUES.SUPER_ADMIN) >= 0)) {
            this.showIconFlag = false;
        } else {
            this.showIconFlag = true;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/primecalendar/booking-entry/booking-entry.component.ts